import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';

export const ChannelListWrapper = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	flexBasis: '400px',
	flexShrink: '0',
	borderRadius: '16px',
	boxShadow: '0px 0px 30px 0px #827D8326',
	background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#fafdff',
	color: theme.palette.text.primary,
	height: 'calc(100vh - 160px)',
	overflow: 'auto',

	[theme.breakpoints.down(960)]: {
		height: 'auto',
		marginBottom: '8px',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingInline: '8px',
	},
}));

export const ChannelListDescription = styled('div')(({ theme }) => ({
	padding: '8px',
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#fff',
	color: theme.palette.text.primary,
	whiteSpace: 'pre',
	marginBottom: '8px',
	boxShadow: 'var(--chat-box-shadow)',
}));

export const ChannelListNavButton = styled(Button)(({ theme }) => ({
	textDecoration: 'underline',
	[theme.breakpoints.up(960)]: {
		display: 'none',
	},
}));
